/*
**  @desc:    推广位统计
**  @author:  yikuang@sohu-inc.com
**  @date:    2017-06-20
*/

import Exposure from '../_utils/exposure';
import SohuStat from './sohu-stat';
import Helper from '../_utils/helper';

var InnerNavStat = (function() {
    var exposure = new Exposure();
    var navList;

    function init(navList) {
        navList = navList || document.querySelectorAll('div[data-inner-nav="true"]');
        addExpose(navList);
        exposure.allExposureCheck();
        exposure.addListener();
    }

    function addExpose(navList) {
        var length = navList.length;
        for(var i=0; i<length; i++) {
            (function(i) {
                var dom = navList[i];
                exposure.add({
                    dom: dom,
                    callback: function() {
                        SohuStat.sendActionStat('10120455');
                    }
                });
            })(i);
        }
    }

    return {
        init: init,
        addExpose: addExpose
    };
})();

export default InnerNavStat;


// WEBPACK FOOTER //
// ./src/statistics/inner-nav-stat.js